import { api } from '@utils'

import {
	GetAllFacilityResponse,
	GetAllFacilityParams,
	FacilityService
} from '.'

const getAllFacilities = async (
	params: GetAllFacilityParams
): Promise<GetAllFacilityResponse> => {
	try {
		const res = await api.get<GetAllFacilityResponse>('/master/facility', {
			params
		})
		return res.data
	} catch (e) {
		throw e
	}
}

export const facilityService: FacilityService = {
	getAllFacilities
}
